// extracted by mini-css-extract-plugin
export var large = "styles-module--large--1ec3d";
export var logo = "styles-module--logo--96457";
export var medium = "styles-module--medium--3197a";
export var small = "styles-module--small--d1de2";